import VueRouter from 'vue-router';

const routes = [
    {
        name: 'home',
        path: '/',
        component: () => {
            if (window.location.href.indexOf('/product/bookkeeping') > -1) {
                return import('../pages/agentBookkeeping.vue');
            }
            return import('../pages/tms.vue');
        }
    },
    {
        name: 'tms',
        path: '/tms',
        component: () => import('../pages/tms.vue')
    },
    {
        name: 'bla',
        path: '/bla',
        component: () => import('../pages/bla.vue')
    },
    {
        name: 'bookkeeping',
        path: '/bookkeeping',
        component: () => import('../pages/bookkeeping.vue')
    },
    {
        name: 'agentBookkeeping',
        path: '/bkp/detail',
        component: () => import('../pages/agentBookkeeping.vue')
    },
    {
        name: 'service',
        path: '/service',
        component: () => import('../pages/service.vue')
    }
];

export default new VueRouter({
    routes
});